import { BaseDto } from '@app/_models/_DTOs/baseDto';
import { Asset } from '@app/_models/_DTOs/asset';
import { Document } from '@app/_models/_DTOs/document';
import { Department } from '@app/_models/_DTOs/department';
import { User } from '@app/_models/_DTOs/user';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { Employee } from '@app/_models/_DTOs/employee';
import { Location } from '@app/_models/_DTOs/location';
import { AssetHistoryDocumentStatus } from '../enums/assetHistoryDocumentStatus';

export class AssetHistoryAction{
    constructor(name: string, color: string, icon: string){
        this.name = name;
        this.color = color;
        this.icon = icon;
    }
    name: string;
    color: string;
    icon: string;
}
export const AssetHistoryActionName = new Map<AssetHistoryActionType, AssetHistoryAction>([
    [AssetHistoryActionType.AssignToEmployee, new AssetHistoryAction("Zaduživanje osobe", "green", "user-add")],
    [AssetHistoryActionType.UnassignFromEmployee, new AssetHistoryAction("Razduživanje osobe", "red", "user-delete")],
    [AssetHistoryActionType.AssignToDepartment, new AssetHistoryAction("Dodjeljivanje radnoj jedinici", "green", "plus-square")],
    [AssetHistoryActionType.UnassignFromDepartment, new AssetHistoryAction("Razduživanje iz radne jedinice", "red", "minus-square")],
    [AssetHistoryActionType.AssignToLocation, new AssetHistoryAction("Dodjeljivanje lokaciji", "green", "environment")],
    [AssetHistoryActionType.UnassignFromLocation, new AssetHistoryAction("Razduživanje iz lokacije", "red", "environment")]
  ]);

export class AssetHistory extends BaseDto {
    actionType: AssetHistoryActionType;
    note: string;
    time: Date;
    logTime: Date;
    confirmed: boolean;
    asset: Asset;
    documents: Document[];
    documentStatus: AssetHistoryDocumentStatus;
    newEmployee: Employee;
    oldEmployee: Employee;
    newDepartment: Department;
    newLocation: Location;
    oldDepartment: Department;
    oldLocation: Location;
    lastUpdatedBy: User;
}